import { useFormCreator } from '@/hooks/forms';
import { CirclePlus } from 'lucide-react';
import { Button } from '@/components/ui';
import { useCreators } from '../hooks';

const ButtonAddCreator = () => {

  const { isLoading: isLoadingCreators } = useCreators();
  const { create } = useFormCreator();

  const handleOnClickBtnAdd = () =>
    create({});

  return (
    <Button
      disabled={isLoadingCreators}
      variant={'secondary'}
      onClick={handleOnClickBtnAdd}
      title='Ajouter un créateur'
      className='my-auto space-x-1 ms-auto'>
      <CirclePlus size={16} />
      <span className='text-xs'>
        Ajouter
      </span>
    </Button>
  );

};

export default ButtonAddCreator;
